module.exports = __webpack_public_path__ + "static/screen1-5af98909580a41631903e771a4b75044.png";